import { useEffect, useState } from "react"

function formatTime(date: Date): string {
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: undefined,
    hour12: true,
  })
}

function formatDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  })
}

export function TopNavClock() {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 15000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="text-right text-xs leading-tight text-white/90">
      <div className="font-medium">{formatTime(now)}</div>
      <div>{formatDate(now)}</div>
    </div>
  )
}
